import { render, staticRenderFns } from "./Pendencies.vue?vue&type=template&id=1994af2a&scoped=true&"
import script from "./Pendencies.vue?vue&type=script&lang=js&"
export * from "./Pendencies.vue?vue&type=script&lang=js&"
import style0 from "./Pendencies.vue?vue&type=style&index=0&id=1994af2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1994af2a",
  null
  
)

export default component.exports